const GETTERS = {
  isStopScroll: state => {
    return state.isStopScroll
  },
  isOpen: state => {
    return state.isOpen
  }
}

export default GETTERS



// WEBPACK FOOTER //
// ./src/store/modules/ui/getters.js